// extracted by mini-css-extract-plugin
export default {"container":"detail_container__zYori","table":"detail_table__nNSsw","d-flex":"detail_d-flex__BNhKD"};